import { Drawer, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "Util/getCustomColor";

export const SidebarContainer = styled("div")({
  display: "flex",
  overflow: "hidden",
});

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  "& .MuiDrawer-paper": {
    borderRight: "1px solid #E5E7EB",
    boxSizing: "border-box",
    overflowX: "auto",
    transition: "width 0.3s ease",
    backgroundColor: "#fff",

    maxHeight: "100vh",
  },
}));

export const UserProfileMenuHeader = styled(Grid)(() => ({
  backgroundColor: "#FFFFFF",
  display: "flex",
  alignItems: "center",
}));

export const UserProfileImage = styled("img")(() => ({
  width: "2.5rem",
  height: "2.5rem",
  minWidth: "2.5rem",
  objectFit: "cover",
  borderRadius: "50%",
}));

export const CompanyUserAndEmailWrapper = styled(Grid)(() => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  minWidth: 0,
  flex: 1,
}));

export const UserProfileName = styled("p")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "1rem",
  color: "#465869",
  margin: 0,
}));

export const Divider = styled("hr")(() => ({
  margin: "auto",
  backgroundColor: "#E2E8F0",
  width: "85%",
}));

export const DividerIcons = styled("hr")(() => ({
  margin: "auto",
  backgroundColor: getBrandCustom("pressedColor", "#667085"),
  width: "3.125rem",
}));

export const ConfigurationsSectionTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "0.625rem",
  color: "#98A2B3",
  textTransform: "uppercase",
  marginBottom: "0.25rem",
}));
